<template>
  <el-select
    v-model="search"
    filterable
    placeholder="Seleccionar medicamento"
    class="app-medication-select"
    :loading="loading"
    :disabled="disabled"
    @input="handleItemSelect">
    <el-option
      v-for="medication in medications"
      :key="medication.reference"
      :label="medication.display"
      :value="medication.reference"
      :class="{ 'app-medication-select__option--recommended': medication.recommended }" />
  </el-select>
</template>

<script>
export default {
  name: 'AppMedicationSelect',
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    medications: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      search: this.value.display || ''
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue.reference !== oldValue.reference) {
        this.search = newValue.display;
      }
    }
  },
  methods: {
    handleItemSelect(value) {
      this.$emit('input', JSON.parse(JSON.stringify(this.medications.find(m => m.reference === value))));
    }
  }
};
</script>
<style lang="scss">
.app-medication-select {
  &__option {
    &--recommended {
      span:before {
        content: '*';
        position: absolute;
        left: $--spacing-3;
        top: $--spacing-1;
        color: $--color-red;
      }
    }
  }
}
</style>
